import { decodeEncodedValue, encodeValue } from '~/utils/cookie';

const YEAR_FROM_NOW = 365 * 24 * 60 * 60 * 1000;

export function getCookie(name: string) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);

  if (parts.length === 2) {
    // extracts the cookie value
    const rawValue = parts.pop()?.split(';').shift();

    if (rawValue) {
      try {
        return decodeEncodedValue(rawValue);
      } catch (error) {
        console.error('Cookie decoding error:', error);
        return null;
      }
    }
  }

  return null;
}

export function setCookie(name: string, value: string | undefined, expiresDate?: Date) {
  try {
    if (!value) {
      // delete the cookie
      document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; SameSite=Lax`;

      return;
    }

    const encoded = encodeValue(value);

    let date: Date;

    if (expiresDate) {
      date = expiresDate;
    } else {
      date = new Date();
      date.setTime(date.getTime() + YEAR_FROM_NOW);
    }

    const expires = `expires=${date.toUTCString()}`;

    document.cookie = `${name}=${encoded};${expires};path=/;SameSite=Lax`;
  } catch (error) {
    console.error('Cookie setting error:', error);
  }
}
